<div class="evir-app">
  <div class="app-w-100 app-pl-16">
    <app-simple-tabs
      *ngIf="showTabs"
      (clicked)="onTabClicked($event)"
      [tabs]="tabs"></app-simple-tabs>
  </div>
  <router-outlet></router-outlet>
</div>
